<template>
  <div class="course-container">
    <Header />
    <div class="course-box">
      <div class="container">
        <div class="search-input">
          <el-input placeholder="输入关键词" v-model="params.searchContent">
          </el-input>
          <el-button @click="handleSearch" v-pointerReClick>查询</el-button>
          <div class="search-tip" v-if="isResult">
            <span class="h">搜索结果</span>与关键词"<span class="blue">{{
              searchContent
            }}</span
            >"相关约内容有{{ total }}条
          </div>
        </div>
        <div class="use-content" v-if="!isResult">
          <!-- 教程视频 -->
          <course-video
            ref="courseVideo" />
          <div class="mt40"></div>
          <use-list />
          <!-- 
          <div class="title"><i></i>使用必读</div>
          <div class="use-list">
            <div class="use-item" v-for="item in courseList" :key="item.id">
              <div class="title" @click="handleJump(item.id)">
                {{ item.title }}
              </div>
              <ul v-for="(items, index) in item.previews.slice(0)" :key="index">
                <li @click="handleJump(item.id, index)">
                  {{ items.title }}
                </li>
              </ul>
              <div class="query-all" v-if="item.previews.length > 4" @click="handleJump(item.id)">查看更多></div>
            </div>
          </div> 
          -->
        </div>
        <div class="search-result" v-else>
          <div class="result-box">
            <template v-if="searchList.length > 0">
              <div class="item" v-for="item in searchList" :key="item.id">
                <div class="title" :ref="item.id" v-html="item.title" @click="handleJump(item.id)"></div>
                <div class="txt" v-html="item.preview" @click="handleJump(item.id)"></div>
              </div>
            </template>
            <div class="result-null" v-else>
              <img src="../../assets/use-course/use-null.png" alt="" />
              <div class="null-txt">暂无您要搜索的数据！</div>
            </div>
          </div>
          <el-pagination
            v-if="searchList.length > 0"
            background
            layout="prev, pager, next,jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="params.pageNo"
            :page-size="params.pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getTutorialOverview, getTutorialPage } from '@/api/course.js'
import { setItem } from '@/utils/storage.js'
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import CourseVideo from './course-video'
import UseList from './components/useList.vue'
export default {
  name: 'course',
  components: {
    UseList,
    CourseVideo,
    Header,
    Footer
  },
  props: {},
  data() {
    return {
      courseVideosList: [],
      courseList: [],
      total: 100,
      params: {
        pageNo: 1,
        pageSize: 10,
        searchContent: ''
      },
      isResult: false,
      searchList: [],
      searchContent: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    // this.getTutorialOverview()
  },
  mounted() { },
  methods: {
    rollVideos() {
      this.$nextTick(() => {
        let $dome = this.$refs.courseVideo.$el
        window.scrollTo({
          top: $dome.offsetTop, // 滚动距离
          behavior: 'smooth'
        })
      })
    },
    async getTutorialOverview() {
      let res = await getTutorialOverview()
      if (res.success) {
        this.courseList = res.data
      }
      /* const { params: { type } } = this.$route
      if (type === 'courseVideo') this.rollVideos() */
    },
    async getTutorialPage() {
      let res = await getTutorialPage(this.params)
      if (res.success) {
        this.searchList = res.data.data
        this.searchContent = JSON.parse(JSON.stringify(this.params.searchContent))
        this.searchList.forEach(item => {
          item.title = item.title.replace(this.params.searchContent, `<span style="color: #3C7CFF;">${this.params.searchContent}</span>`)
          item.preview = item.preview.replaceAll(this.params.searchContent, `<span style="color: #3C7CFF;">${this.params.searchContent}</span>`)
        })
        this.total = res.data.totalRecord
        this.isResult = true
      }
    },
    handleSearch() {
      /* if (!getItem('userInfo')) {
        this.$eventBus.$emit('openLoginDV')
        return false
      } */
      this.params.pageNo = 1
      this.getTutorialPage()
    },
    handleJump(id, type) {
      if (type !== undefined) {
        if (id == 5) {
          type += 1
        }
        setItem('type',type+'')
      }
      window.open(location.origin + `/course?id=${id}`)
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getTutorialPage()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val
      this.getTutorialPage()
    }
  }
}
</script>

<style scoped lang="scss">
.course-container {
  position: relative;
  width: 100%;
  padding-top: 80px;
  .course-box {
    display: flex;
    justify-content: center;
    background: url('../../assets/use-course/course-bg.png') no-repeat;
    background-size: 100% 528px;
    width: 100%;
    padding-top: 70px;
    .container {
      width: 1200px;
    }
    .search-input {
      display: flex;
      position: relative;
      margin-bottom: 60px;
      margin-left: 100px;
      .el-input {
        width: 880px;
        ::v-deep.el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .el-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        color: #fff;
        background-color: #3c7cff;
        border: 1px solid #3c7cff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        font-size: 14px;
        font-weight: 400;
      }
      .search-tip {
        position: absolute;
        bottom: -30px;
        left: 50%;
        transform: translate(-50%, 0);
        font-family: Source Han Sans CN;
        color: #24232f;
        font-size: 14px;
        .h {
          font-weight: 400;
          font-size: 20px;
          margin-right: 8px;
        }
        .blue {
          color: #3c7cff;
        }
      }
    }
    .use-content {
      margin-bottom: 180px;
      .title {
        i {
          display: inline-block;
          width: 22px;
          height: 22px;
          background: url('../../assets/use-course/course-svg.svg') no-repeat;
          background-size: 100%;
          vertical-align: middle;
          margin-right: 8px;
        }
        font-size: 20px;
        font-weight: bold;
        color: #232835;
        margin-bottom: 28px;
      }
      .use-list {
        display: flex;
        justify-content: space-between;
        .use-item {
          position: relative;
          width: 380px;
          height: 500px; /* 356px */
          overflow-y: auto;
          padding: 30px 24px;
          box-shadow: 0px 2px 10px 0px rgba(255, 255, 255, 0.1),
            0px 6px 26px 0px rgba(95, 139, 230, 0.16);
          border-radius: 8px;
          color: #24232f;
          background: rgba(255, 255, 255, 0.4);
          .title {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 16px;
            cursor: pointer;
          }
          ul {
            padding-left: 20px;
            font-size: 14px;
            font-weight: 400;
            line-height: 38px;
            li {
              cursor: pointer;
            }
            li:hover {
              color: #3c7cff;
            }
            .line {
              line-height: 28px;
              margin-bottom: 6px;
            }
          }
          .query-all {
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translate(-50%, 0);
            font-size: 14px;
            font-weight: 400;
            color: #3c7cff;
            cursor: pointer;
          }
        }
      }
    }
    .search-result {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-bottom: 80px;
      .result-box {
        width: 1200px;
        padding: 0 30px 30px;
        background: #ffffff;
        box-shadow: 0px 2px 10px 0px rgba(255, 255, 255, 0.1),
          0px 6px 26px 0px rgba(95, 139, 230, 0.16);
        border-radius: 8px;
        margin-bottom: 30px;
        .result-null {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 100px;
          height: 660px;
          img {
            width: 193px;
            height: 198px;
          }
          .null-txt {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #a3aab7;
            line-height: 30px;
          }
        }
        .item {
          padding: 30px 0;
          border-bottom: 1px solid #e8ebf3;
          font-family: Source Han Sans CN;
          cursor: pointer;
          .title {
            font-size: 18px;
            font-weight: 600;
            color: #24232f;
            margin-bottom: 12px;
          }
          .txt {
            font-size: 14px;
            font-weight: 400;
            color: #767d8f;
            line-height: 30px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          &:last-child {
            border-bottom: 0;
          }
        }
      }
      ::v-deep.el-pagination {
        .btn-prev,
        .btn-next,
        .number {
          line-height: 25px;
          background-color: #fff;
          border: 1px solid #e8e9f0;
          border-radius: 4px;
        }
        .active {
          background-color: #3c7cff;
        }
        .el-icon-more {
          background: #fff;
        }
      }
    }
  }
}
</style>
